/**
 * Licensed Materials - Property of IBM	
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020	
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.	
 */

define([
	'./OpenDialog',
	'./SaveAsDialog',
	'./CopyMoveDialog'
], function(OpenDialog, SaveAsDialog, CopyMoveDialog) {

	class ContentDialogFactory {

		createOpenDialog(options) {
			return new OpenDialog(options);
		}

		createSaveAsDialog(options) {
			return new SaveAsDialog(options);
		}

		createCopyMoveDialog(options) {
			return new CopyMoveDialog(options);
		}

	}

	return ContentDialogFactory;

});
